// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
// строковый филд
import { PFixField } from './PFixField';
export class PFixStringField extends PFixField {
    constructor(fieldId, buffer) {
        super(fieldId, buffer);
        this.Value = '';
    }
    ReadValue(buffer) {
        this.Value = buffer.ReadString();
    }
    Write(buffer) {
        buffer.WriteShort(this.FieldId);
        buffer.WriteString(this.Value);
    }
}
